import { isTranslationSynced, viewTranslationByLocale, } from "@lookiero/i18n";
import { useQuery } from "@lookiero/messaging-react";
const useViewTranslationForLocale = ({ locale, contextId, }) => useQuery({
    query: viewTranslationByLocale({ locale }),
    invalidation: (event) => isTranslationSynced(event) && event.locale === locale,
    options: {
        staleTime: 60 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: false,
    },
    contextId,
});
export { useViewTranslationForLocale };
